import React, { useState } from "react";
import "./WithdrawalModal.css";
import { toast } from "react-toastify";

const WithdrawalModal = ({ withdrawal, onClose, onAction }) => {
  const [loading, setLoading] = useState(false);

  if (!withdrawal) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleActionClick = async (action) => {
    const adminComment = prompt("Enter admin remark:");
    if (!adminComment) return;

    setLoading(true);
    try {
      await onAction(withdrawal.id, action, adminComment);
      onClose();
    } catch (err) {
      alert("Action failed: " + err.message);
    }
    setLoading(false);
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${label} copied to clipboard!`);
    }).catch(() => {
      toast.error(`Failed to copy ${label}`);
    });
  };

  const renderDetailRow = (label, value) => (
    <div className="detail-row">
      <span className="detail-label">{label}</span>
      <span className="detail-colon">:</span>
      <span className="detail-value">{value}</span>
    </div>
  );

  return (
    <div className="withdrawal-modal-overlay" onClick={handleOverlayClick}>
      <div className="withdrawal-modal-content">
        {/* Close Button */}
        <button className="modal-close-btn" onClick={onClose}>
          ×
        </button>
      
        <div className="sections-container" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          
          {/* Section 1: Withdrawal Details */}
          <div className="section" style={{ flex: "1 1 250px" }}>
            <h2>Withdrawal Details</h2>
            <div className="withdrawal-details">
              {renderDetailRow("Client Email", withdrawal.email || "-")}
              {renderDetailRow("Withdrawal Amount", `$ ${withdrawal.amount || "0"}`)}
              {renderDetailRow("Trading Account", withdrawal.trade_id || "-")}
              {renderDetailRow("Withdrawal Method", withdrawal.type || "-")}
              {renderDetailRow("From", withdrawal.from || "-")}
              {renderDetailRow("To", withdrawal.to || "-")}
              {renderDetailRow("Reference ID", withdrawal.reference_id || "-")}
            </div>
          </div>

          {/* Section 2: Payment Information */}
          <div className="section" style={{ flex: "1 1 250px" }}>
            <h2>Payment Information</h2>
            <div className="withdrawal-details">
              {renderDetailRow("Payment Method", 
                <span className="font-medium text-blue-600 capitalize">
                  {withdrawal.payout_method || 'N/A'}
                </span>
              )}
              {withdrawal.wallet_address ? (
                <div className="detail-row">
                  <span className="detail-label">Wallet Address</span>
                  <span className="detail-colon">:</span>
                  <div className="detail-value" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span 
                      className="wallet-address" 
                      style={{ 
                        fontFamily: 'monospace', 
                        backgroundColor: '#f3f4f6', 
                        padding: '4px 8px', 
                        borderRadius: '4px',
                        fontSize: '12px',
                        wordBreak: 'break-all',
                        maxWidth: '200px'
                      }}
                    >
                      {withdrawal.wallet_address}
                    </span>
                    <button
                      onClick={() => copyToClipboard(withdrawal.wallet_address, 'Wallet address')}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '16px',
                        padding: '4px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      title="Copy wallet address"
                    >
                      📋
                    </button>
                  </div>
                </div>
              ) : (
                renderDetailRow("Wallet Address", "N/A")
              )}
            </div>
          </div>

          {/* Section 3: Withdrawal Status */}
          <div className="section" style={{ flex: "1 1 200px" }}>
            <h2>Withdrawal Status</h2>
            <div className="withdrawal-details">
              {renderDetailRow("Withdrawal Date", new Date(withdrawal.created_at).toLocaleString())}
              {renderDetailRow(
                "Status",
                <span className={`status ${withdrawal.status || "pending"}`}>
                  {withdrawal.status || "pending"}
                </span>
              )}
              {renderDetailRow("Admin Remark", withdrawal.admin_comment || "Waiting for approval")}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="modal-actions">
          {withdrawal.status === "pending" && (
            <>
              <button
                className="action-btn approve"
                onClick={() => handleActionClick("approve")}
                disabled={loading}
              >
                Approve
              </button>
              <button
                className="action-btn reject"
                onClick={() => handleActionClick("reject")}
                disabled={loading}
              >
                Reject
              </button>
            </>
          )}
         
          
        </div>
      </div>
    </div>
  );
};

export default WithdrawalModal;
